
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-45e5a69c\",\"scoped\":false,\"hasInlineConfig\":true}!../vue-loader/lib/selector?type=styles&index=0!./upload-2.vue")

var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./upload-2.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-45e5a69c\"}!../vue-loader/lib/selector?type=template&index=0!./upload-2.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/shared/frontend/node_modules/vue-image-crop-upload/upload-2.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] upload-2.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45e5a69c", Component.options)
  } else {
    hotAPI.reload("data-v-45e5a69c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-image-crop-upload/upload-2.vue
// module id = 989
// module chunks = 0